//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface ApiExceptionResponse {
    title: string;
    errorType: string;
    message: string;
    stackTrace: string;
    extensions: { [key: string]: any };
}

export interface BasketResponse {
    basketReference: string;
    updated: Date;
    paymentTransactionId?: string | undefined;
    orderNumber?: number | undefined;
    customerAddress?: AddressDetails | undefined;
    appliedVouchers?: Voucher[] | undefined;
    termsAccepted: boolean;
    newsletterSignUp: boolean;
    basketState: BasketStates;
    contexts?: BasketContextResponse[] | undefined;
    discountFromVouchers: PriceModel;
    subTotal: PriceModel;
    total: PriceModel;
    freightPrice: PriceModel;
    quantity: number;
    gaClientId?: string | undefined;
    gaSessionId?: string | undefined;
    isValid: boolean;
    hasValidationErrors: boolean;
    packagingAmount: PriceModel;
}

export interface AddressDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    addressId?: string | undefined;
    addressType?: DeliveryAddressType | undefined;
    addressReference?: string | undefined;
}

export enum DeliveryAddressType {
    Normal = 0,
    ParcelShop = 1,
    WarehousePickup = 2,
}

export interface Voucher {
    code?: string | undefined;
    priceModel?: PriceModel | undefined;
}

export interface PriceModel {
    priceExVat: number;
    priceInclVat: number;
    vatPercent: number;
}

export enum BasketStates {
    Created = 'Created',
    Updated = 'Updated',
    CheckedOut = 'CheckedOut',
    Completed = 'Completed',
}

export interface BasketContextResponse {
    name?: string | undefined;
    packagingAmount: PriceModel;
    freights?: BasketFreightResponse[] | undefined;
    amount: PriceModel;
    quantity: number;
}

export interface BasketFreightResponse {
    deliveryId: number;
    freightType: FreightType;
    freightTypeName?: string | undefined;
    freightTypeNameValue?: string | undefined;
    m3FreightType?: string | undefined;
    m3DeliveryCode?: string | undefined;
    m3DeliveryDescription?: string | undefined;
    deliveryAddress?: AddressDetails | undefined;
    deliveryDate?: Date | undefined;
    customerComment?: string | undefined;
    freightProvider?: string | undefined;
    freightOption?: FreightOption | undefined;
    freightTypeImage?: string | undefined;
    allowCustomerComment: boolean;
    amount: PriceModel;
    quantity: number;
    freightPrice: PriceModel;
    calculatedDeliveryDate?: Date | undefined;
    brands?: BasketBrandReponse[] | undefined;
    pickupInfo?: BasketPickupInfo | undefined;
    deliveryTitle?: Translation | undefined;
    freightPriceState: DeliveryPriceDetailsState;
    deliveryInfoState: DeliveryInfoState;
    stockInfo?: BasketStockInfo | undefined;
    packagingAmount: PriceModel;
    totalAmount: PriceModel;
    isFreeDelivery: boolean;
}

export enum FreightType {
    OnlyRetrieval = 'OnlyRetrieval',
    Postal = 'Postal',
    Stykgods = 'Stykgods',
    DirectDelivery = 'DirectDelivery',
    KvantumFreight = 'KvantumFreight',
    AlwaysFreight = 'AlwaysFreight',
}

export enum FreightOption {
    ParcelShop = 'ParcelShop',
    HomeDelivery = 'HomeDelivery',
    HomeDeliveryFlex = 'HomeDeliveryFlex',
    Business = 'Business',
}

export interface BasketBrandReponse {
    name?: string | undefined;
    items?: BasketItemResponse[] | undefined;
    amount: PriceModel;
    quantity: number;
}

export interface BasketItemResponse {
    productItemId: number;
    itemNumber?: string | undefined;
    context?: string | undefined;
    freightTypeName?: string | undefined;
    freightType: FreightType;
    name?: string | undefined;
    name2?: string | undefined;
    variantType?: string | undefined;
    variantName?: string | undefined;
    itemUrl?: string | undefined;
    packagingItemNumber?: string | undefined;
    packagingQuantity?: number | undefined;
    packagingSalesUnitValue?: string | undefined;
    salesUnit?: string | undefined;
    salesUnitValue?: string | undefined;
    quantity: number;
    weight: number;
    euGaranEnabled?: boolean | undefined;
    euGaranBrand?: string | undefined;
    euGaranModelIdentifier?: string | undefined;
    euGaranYears?: number | undefined;
    appliedVouchers?: string[] | undefined;
    activeCampaigns?: ActiveCampaignDetails[] | undefined;
    image?: ProductQueryResource | undefined;
    updated: Date;
    itemStatus: ItemStatusValues;
    categoryBreadcrumb?: string | undefined;
    bundleId?: string | undefined;
    isBundledItem: boolean;
    isOrderItem: boolean;
    validationError?: BasketValidationError | undefined;
    originalPrice?: PriceModel | undefined;
    price: PriceModel;
    unitDiscount?: PriceModel | undefined;
    totalDiscount?: PriceModel | undefined;
    discountPercent: number;
    subTotal: PriceModel;
    originalSubTotal?: PriceModel | undefined;
    packagingPrice?: PriceModel | undefined;
    stockDetails?: StockDetails | undefined;
    calculatedDeliveryDate?: Date | undefined;
    invoiceDepartmentId?: number | undefined;
    wareHouseId?: number | undefined;
}

export interface ActiveCampaignDetails {
    entityId: number;
    url?: string | undefined;
    linkText?: string | undefined;
    priority?: number | undefined;
    campaignTypes?: string[] | undefined;
    fontColorCode?: string | undefined;
    labelColorCode?: string | undefined;
    lastModifiedFormatted?: string | undefined;
    freeDelivery?: boolean | undefined;
    filterName?: string | undefined;
    description?: string | undefined;
    normalPrice?: PriceModel | undefined;
    campaignPrice?: PriceModel | undefined;
    normalBuyPrice?: PriceModel | undefined;
    buyPrice?: PriceModel | undefined;
    bulk?: string | undefined;
    buyAgreements?: string | undefined;
    comments?: string | undefined;
    quantity?: string | undefined;
    name?: string | undefined;
    labelDescription?: string | undefined;
    title?: string | undefined;
    text?: string | undefined;
}

export interface ProductQueryResource {
    displayName?: string | undefined;
    fileName?: string | undefined;
    link?: string | undefined;
    path?: string | undefined;
    mimetype?: string | undefined;
    resourceType?: string | undefined;
    resourceType2?: string | undefined;
    height?: number | undefined;
    width?: number | undefined;
    blurHash?: string | undefined;
}

export enum ItemStatusValues {
    Inactive = 'Inactive',
    Active = 'Active',
    Discontinued = 'Discontinued',
    Obsolete = 'Obsolete',
    Unknown = 'Unknown',
}

export interface BasketValidationError {
    status: ItemStatusValues;
    validationError?: string | undefined;
    validationText?: Translation | undefined;
}

export interface Translation {
    name?: string | undefined;
    values?: TranslationValue[] | undefined;
}

export interface TranslationValue {
    type: TranslationValueType;
    key?: string | undefined;
    value?: any | undefined;
    format?: string | undefined;
}

export enum TranslationValueType {
    String = 'String',
    Integer = 'Integer',
    Decimal = 'Decimal',
    Currency = 'Currency',
    DateTime = 'DateTime',
    Date = 'Date',
    Time = 'Time',
}

export interface StockDetails {
    quantity: number;
    status: StockStatus;
    salesUnit?: string | undefined;
    primaryWarehouseId?: string | undefined;
}

export enum StockStatus {
    Unavailable = 'Unavailable',
    OutOfStock = 'OutOfStock',
    LowStock = 'LowStock',
    InStock = 'InStock',
}

export interface BasketPickupInfo {
    departmentName?: string | undefined;
    pickupTime?: Date | undefined;
    pickupDelay?: string | undefined;
}

export enum DeliveryPriceDetailsState {
    NotCalculated = 'NotCalculated',
    Valid = 'Valid',
    IsIsland = 'IsIsland',
    MissingFreightZone = 'MissingFreightZone',
    MissingFreightPrice = 'MissingFreightPrice',
    MissingFreightType = 'MissingFreightType',
    MissingWeightLimitPrice = 'MissingWeightLimitPrice',
    InvalidPostalCode = 'InvalidPostalCode',
    MissingProductPrice = 'MissingProductPrice',
    MissingFreightSettings = 'MissingFreightSettings',
    MultipleFreightTypes = 'MultipleFreightTypes',
}

export enum DeliveryInfoState {
    NotCalculated = 'NotCalculated',
    Valid = 'Valid',
    Invalid = 'Invalid',
}

export interface BasketStockInfo {
    departmentName?: string | undefined;
}

export interface BasketItemOptions {
    userId?: string | undefined;
    warehouseId?: number | undefined;
    postalCode?: string | undefined;
    quantity: number;
    isBundle: boolean;
}

export interface CustomerAddressDetails extends AddressDetails {
    newsletterSignup: boolean;
    termsAccepted: boolean;
}

export interface UpdateDeliveryMethodRequest {
    freightProvider?: string | undefined;
    freightOption?: FreightOption | undefined;
    parcelServicePoint?: ParcelServicePoint | undefined;
}

export interface ParcelServicePoint {
    id?: string | undefined;
    shippingProviderName?: string | undefined;
    name?: string | undefined;
    countryCode?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    lat?: string | undefined;
    long?: string | undefined;
    distanceInMeters: number;
    openingHours?: ParcelPointOpeningHours[] | undefined;
}

export interface ParcelPointOpeningHours {
    day?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
}

export interface DeliveryOptionsResponse {
    freightType: FreightType;
    freightTypeName?: string | undefined;
    deliveryPrices?: FreightTypeDeliveryPriceDetails[] | undefined;
}

export interface FreightTypeDeliveryPriceDetails {
    freightOption?: FreightOption | undefined;
    freightSupplier?: string | undefined;
    freightSupplierImage?: string | undefined;
    deliveryPrice?: DeliveryPriceDetails | undefined;
    deliveryDate?: Date | undefined;
    deliveryDateMaxEstimate?: Date | undefined;
    deliveryDescription?: Translation | undefined;
    freightType: FreightType;
}

export interface DeliveryPriceDetails {
    price: PriceModel;
    totalPrice: PriceModel;
    isExact: boolean;
    m3Code?: string | undefined;
    freightType: FreightType;
    surcharges?: FreightSurcharge[] | undefined;
    deliveryPriceDetailsState: DeliveryPriceDetailsState;
    isFreeDelivery: boolean;
}

export interface FreightSurcharge {
    surchargeType: FreightSurchargeType;
    surchargePercent?: number | undefined;
    surchargePrice: PriceModel;
}

export enum FreightSurchargeType {
    Handling = 'Handling',
    Environmental = 'Environmental',
    Oil = 'Oil',
}

export interface Exception {
    targetSite?: MethodBase | undefined;
    message: string;
    data: Data[];
    innerException?: Exception | undefined;
    helpLink?: string | undefined;
    source?: string | undefined;
    hResult: number;
    stackTrace?: string | undefined;
}

export interface VoucherValidationException extends Exception {
    validationError?: VoucherValidationError | undefined;
}

export interface VoucherValidationError {
    validationError?: string | undefined;
    validationText?: Translation | undefined;
}

export interface MemberInfo {
    memberType: MemberTypes;
    name: string;
    declaringType?: string | undefined;
    reflectedType?: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    metadataToken: number;
}

export interface MethodBase extends MemberInfo {
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
}

export enum MethodAttributes {
    PrivateScope = 0,
    ReuseSlot = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    MemberAccessMask = 7,
    UnmanagedExport = 8,
    Static = 16,
    Final = 32,
    Virtual = 64,
    HideBySig = 128,
    NewSlot = 256,
    VtableLayoutMask = 256,
    CheckAccessOnOverride = 512,
    Abstract = 1024,
    SpecialName = 2048,
    RTSpecialName = 4096,
    PinvokeImpl = 8192,
    HasSecurity = 16384,
    RequireSecObject = 32768,
    ReservedMask = 53248,
}

export enum MethodImplAttributes {
    IL = 0,
    Managed = 0,
    Native = 1,
    OPTIL = 2,
    CodeTypeMask = 3,
    Runtime = 3,
    ManagedMask = 4,
    Unmanaged = 4,
    NoInlining = 8,
    ForwardRef = 16,
    Synchronized = 32,
    NoOptimization = 64,
    PreserveSig = 128,
    AggressiveInlining = 256,
    AggressiveOptimization = 512,
    InternalCall = 4096,
    Async = 8192,
    MaxMethodImplVal = 65535,
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export interface RuntimeMethodHandle {
    value: IntPtr;
}

export interface IntPtr {}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export interface Module {
    assembly: Assembly;
    fullyQualifiedName: string;
    name: string;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export interface Assembly {
    definedTypes: TypeInfo[];
    exportedTypes: string[];
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion: string;
    isDynamic: boolean;
    location: string;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[];
    escapedCodeBase: string;
    manifestModule: Module;
    modules: Module[];
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export interface Anonymous {
    genericTypeParameters: string[];
    declaredConstructors: ConstructorInfo[];
    declaredEvents: EventInfo[];
    declaredFields: FieldInfo[];
    declaredMembers: MemberInfo[];
    declaredMethods: MethodInfo[];
    declaredNestedTypes: TypeInfo[];
    declaredProperties: PropertyInfo[];
    implementedInterfaces: string[];
}

export interface TypeInfo extends Anonymous {}

export interface ConstructorInfo extends MethodBase {
    memberType: MemberTypes;
}

export interface EventInfo extends MemberInfo {
    memberType: MemberTypes;
    attributes: EventAttributes;
    isSpecialName: boolean;
    addMethod?: MethodInfo | undefined;
    removeMethod?: MethodInfo | undefined;
    raiseMethod?: MethodInfo | undefined;
    isMulticast: boolean;
    eventHandlerType?: string | undefined;
}

export enum EventAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    ReservedMask = 1024,
}

export interface MethodInfo extends MethodBase {
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: string;
    returnTypeCustomAttributes: ICustomAttributeProvider;
    genericParameterCount: number;
}

export interface ParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name?: string | undefined;
    parameterType: string;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export interface CustomAttributeData {
    attributeType: string;
    constructor: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[];
    namedArguments: CustomAttributeNamedArgument[];
}

export interface CustomAttributeTypedArgument {
    argumentType: string;
    value?: any | undefined;
}

export interface CustomAttributeNamedArgument {
    argumentType: string;
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string;
    isField: boolean;
}

export interface ICustomAttributeProvider {}

export interface FieldInfo extends MemberInfo {
    memberType: MemberTypes;
    attributes: FieldAttributes;
    fieldType: string;
    isInitOnly: boolean;
    isLiteral: boolean;
    isNotSerialized: boolean;
    isPinvokeImpl: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    fieldHandle: RuntimeFieldHandle;
}

export enum FieldAttributes {
    PrivateScope = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    FieldAccessMask = 7,
    Static = 16,
    InitOnly = 32,
    Literal = 64,
    NotSerialized = 128,
    HasFieldRVA = 256,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasFieldMarshal = 4096,
    PinvokeImpl = 8192,
    HasDefault = 32768,
    ReservedMask = 38144,
}

export interface RuntimeFieldHandle {
    value: IntPtr;
}

export interface PropertyInfo extends MemberInfo {
    memberType: MemberTypes;
    propertyType: string;
    attributes: PropertyAttributes;
    isSpecialName: boolean;
    canRead: boolean;
    canWrite: boolean;
    getMethod?: MethodInfo | undefined;
    setMethod?: MethodInfo | undefined;
}

export enum PropertyAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasDefault = 4096,
    Reserved2 = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 62464,
}

export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export interface ModuleHandle {
    mdStreamVersion: number;
}

export interface CheckoutQueryResult {
    basketReference: string;
    transactionId?: string | undefined;
    paymentUrl?: string | undefined;
}

export interface CheckoutOptions {
    userId?: string | undefined;
}

export interface ConfirmPaymentResult {
    basketReference: string;
    states: BasketStates;
}

export interface ConfirmPaymentRequest {
    transactionId?: string | undefined;
}

export interface ParcelServicePointQueryResult {
    parcelServicePoints?: ParcelServicePoint[] | undefined;
}

export interface ParcelServicePointQuery {
    street?: string | undefined;
    streetNumber?: string | undefined;
    zipCode?: string | undefined;
    numberOfServicePoints: number;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface Customer {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    addressLine1?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    financialData?: FinancialData | undefined;
    orderData?: OrderDataSummary | undefined;
    ediCustomer: boolean;
    company?: string | undefined;
    mobilePhone?: string | undefined;
    prettyName?: string | undefined;
}

export interface FinancialData {
    creditLimit: number;
    status: number;
    outstandingInvoice: number;
    notInvoiced: number;
    unlimitedCredit: boolean;
    currentCredit: number;
    cashDiscountTerm?: string | undefined;
    overdueInvoiceAmount?: number | undefined;
}

export interface OrderDataSummary {
    salesPerson?: string | undefined;
    defaultFacility?: string | undefined;
    freeDelivery: boolean;
    fieldCode?: string | undefined;
    termOfPayment?: string | undefined;
}

export enum CustomerType {
    Pro = 0,
    PrivateAccount = 1,
    Private = 2,
}

export interface UserDto {
    email: string;
    customerId: string;
    customerType?: CustomerType | undefined;
    userName: string;
    phoneNumber: string;
    roles: CustomerRoleDto[];
}

export enum CustomerRoleDto {
    AccountAdministrator = 0,
    Administrator = 1,
    SeeAccountInformationRole = 2,
    ProCustomer = 3,
    PrivateCustomer = 4,
    PriceExportAllowed = 5,
    PlaceOrderRole = 6,
    SeePricesRole = 7,
    SendCopyOfOrderRole = 8,
    AssignPermissionsRole = 100,
    CreateUsersRole = 101,
    CustomerPrivateAccount = 102,
    CustomerPrivateUnregistered = 103,
}

export interface SimpleCustomerListResponse {
    customers?: SimpleCustomerDto[] | undefined;
}

export interface SimpleCustomerDto {
    customerId?: string | undefined;
    customerName?: string | undefined;
}

export interface EditUserRequest {
    customerId: string;
    userId: string;
    userName: string;
    phoneNumber: string;
    roles: CustomerRoleDto[];
}

export interface UserCustomerResponse {
    user?: UserInformationDto | undefined;
    customer?: Customer | undefined;
}

export interface UserInformationDto {
    email: string;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    customerIds: string[];
    currentCustomerId: string;
    currentCustomerRoles: CustomerRoleDto[];
}

export interface UpdateUserInformationRequest {
    name: string;
    phoneNumber: string;
}

export interface AssignableRoleDto {
    roleId: number;
    role: string;
}

export interface CustomerUsersResponse {
    customerId: string;
    users: CustomerUserItemDto[];
}

export interface CustomerUserItemDto {
    userId: string;
    email: string;
    userName: string;
    phoneNumber: string;
    roles: CustomerRoleDto[];
}

export interface OrderHeader {
    orderId?: string | undefined;
    customerId?: string | undefined;
    orderDate: Date;
    status: OrderStatus;
    statusCode?: string | undefined;
    deliveryMethod: DeliveryMethod;
    deliveryAddress?: Address | undefined;
    customersReference?: string | undefined;
    hasInvoice: boolean;
}

export enum OrderStatus {
    Invoiced = 0,
    Delivered = 1,
    Delivering = 2,
    Processing = 3,
    Reserved = 4,
    UseStatusCode = 5,
    Unknown = 6,
}

export enum DeliveryMethod {
    PickUpDirect = 0,
    Pickup = 1,
    Delivery = 2,
    DeliveryDirect = 3,
    Mover = 4,
    Postal = 5,
    PostalBusiness = 6,
    Courier = 7,
    Unknown = 8,
}

export interface Address {
    firstName?: string | undefined;
    lastName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    addressId?: string | undefined;
}

export interface CustomerInfoHeader {
    invoiceNumber?: string | undefined;
    invoiceDate?: Date | undefined;
    dueDate?: Date | undefined;
    currency?: string | undefined;
    invoiceAmount: number;
    remainingAmount: number;
    orderNumber?: string | undefined;
    customerOrderNumber?: string | undefined;
    customerReference?: string | undefined;
    filterValue?: string[] | undefined;
    status?: InvoiceStatus | undefined;
}

export interface InvoiceStatus {
    isOpen: boolean;
    description?: string | undefined;
}

export interface MarshalByRefObject {}

export interface Stream extends MarshalByRefObject {
    canRead: boolean;
    canWrite: boolean;
    canSeek: boolean;
    canTimeout: boolean;
    length: number;
    position: number;
    readTimeout: number;
    writeTimeout: number;
}

export interface OrderDetailsResponse {
    invoiceAddress?: AddressDto | undefined;
    total: number;
    subTotal: number;
    freightTotal: number;
    lines?: OrderlineDto[] | undefined;
    orderNumber?: string | undefined;
    customerNumber?: string | undefined;
    status: OrderStatus;
    orderDate: Date;
    deliveryMethod: DeliveryMethod;
    deliveryAddress?: AddressDto | undefined;
    customersReference?: string | undefined;
    hasInvoice: boolean;
}

export interface AddressDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    addressId?: string | undefined;
}

export interface OrderlineDto {
    productId?: string | undefined;
    quantity: number;
    unitOfMeasure?: string | undefined;
    linePrice: number;
    unitPrice: number;
    itemStatus?: string | undefined;
    brand?: string | undefined;
    name?: string | undefined;
    name2?: string | undefined;
    imageUrl?: string | undefined;
    variantType?: string | undefined;
    variantName?: string | undefined;
    itemCanonicalUrl?: string | undefined;
}

export interface AssignPriceExportRoleRequest {
    email: string;
    customerId: string;
    enable: boolean;
    accountingCredential: string;
}

export interface IAccountStatement {
    year: number;
    month: number;
    data?: string | undefined;
    dateTimeOffset?: Date | undefined;
}

export interface OrderStatusResponse {
    orderStatusNetaxept?: OrderStatusNetaxept[] | undefined;
    orderStatusM3?: OrderStatusResultItem[] | undefined;
}

export interface OrderStatusNetaxept {
    transactionId?: string | undefined;
    childTransactionId?: string | undefined;
    customerInformation?: CustomerInformation | undefined;
    cardInformation?: CardInformation | undefined;
    orderInformation?: OrderInformation | undefined;
    orderStatusSummary?: OrderStatusSummary | undefined;
    error?: NetaxeptError | undefined;
    history?: TransactionLogLine[] | undefined;
}

export interface CustomerInformation {
    customerNumber?: string | undefined;
}

export interface CardInformation {
    expiryDate?: string | undefined;
    issuer?: string | undefined;
    issuerCountry?: string | undefined;
    maskedPan?: string | undefined;
    paymentMethod?: string | undefined;
    issuerId: number;
}

export interface OrderInformation {
    orderNumber?: string | undefined;
    amount: number;
    currency?: string | undefined;
    orderDescription?: string | undefined;
    deliveryDate?: Date | undefined;
    fee: number;
    timestamp?: Date | undefined;
    total: number;
    roundingAmount: number;
}

export interface OrderStatusSummary {
    authorizationId?: string | undefined;
    authorized: boolean;
    amountCaptured: number;
    amountCredited: number;
    annulled: boolean;
}

export interface NetaxeptError {
    message?: string | undefined;
    issuerId?: string | undefined;
    responseSource?: string | undefined;
    responseCode?: string | undefined;
    responseText?: string | undefined;
    operation?: string | undefined;
}

export interface TransactionLogLine {
    dateTime?: Date | undefined;
    description?: string | undefined;
    amount?: number | undefined;
    batchNumber?: number | undefined;
    operation?: string | undefined;
}

export interface OrderStatusResultItem {
    orderNumber?: string | undefined;
    customerNumber?: string | undefined;
    status?: string | undefined;
    orderDate?: Date | undefined;
    freightType: FreightType;
    wareHouseId: number;
    salesDepartmentId: number;
    deliveryId: number;
}

export interface OrderDetails extends OrderHeader {
    invoiceAddress?: Address | undefined;
    total: number;
    subTotal: number;
    freightTotal: number;
    lines?: OrderLine[] | undefined;
}

export interface OrderLine {
    productId?: string | undefined;
    quantity: number;
    unitOfMeasure?: string | undefined;
    linePrice: number;
    unitPrice: number;
    itemDescription?: string | undefined;
    lineDetails?: OrderLineDetails | undefined;
}

export interface OrderLineDetails {
    name?: string | undefined;
    itemName?: string | undefined;
    imageUrl?: string | undefined;
    imagePath?: string | undefined;
    brand?: string | undefined;
    itemUrl?: string | undefined;
}

export interface PostalCodeQueryResult {
    postalCode: string;
    city: string;
}

export interface PriceWithCampaigns {
    entityId: number;
    itemNumber?: string | undefined;
    price?: SalesUnitPrice | undefined;
    alternativePrice?: SalesUnitPrice | undefined;
    splashes?: string[] | undefined;
    activeCampaigns?: ActiveCampaignDetails[] | undefined;
    futureCampaigns?: FutureCampaignDetails[] | undefined;
    activeVouchers?: PercentageVoucher[] | undefined;
}

export interface SalesUnitPrice {
    salesUnit?: string | undefined;
    price: PriceModel;
    originalPrice?: PriceModel | undefined;
    currency?: string | undefined;
    campaign?: string | undefined;
    pluralPrices?: PluralPrice[] | undefined;
    savingsInPercent: number;
    savings: PriceModel;
}

export interface PluralPrice {
    quantity: number;
    price: PriceModel;
}

export interface FutureCampaignDetails {
    name?: string | undefined;
    campaignTypes?: string[] | undefined;
    priority?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface Voucher2 {
    voucherKey?: string | undefined;
}

export interface PercentageVoucher extends Voucher2 {
    percentage: number;
}

export interface ProductQueryResult {
    product?: ProductQueryProduct | undefined;
}

export interface ProductQueryProduct {
    productId: number;
    primaryItemNumber?: string | undefined;
    name?: string | undefined;
    name2?: string | undefined;
    shortDescription?: string | undefined;
    longDescription?: string | undefined;
    productFAQ?: string | undefined;
    contextGroupKey?: string | undefined;
    contextGroupName?: string | undefined;
    brand?: string | undefined;
    subBrand?: string | undefined;
    salesUnitFormatted?: string | undefined;
    salesUnitLookup?: string | undefined;
    alternativeSalesUnitFormatted?: string | undefined;
    alternativeSalesUnitLookup?: string | undefined;
    shop?: string | undefined;
    shopName?: string | undefined;
    item?: ProductQueryProductItem | undefined;
    variants?: ProductQueryProductItem[] | undefined;
    images?: ProductQueryResource[] | undefined;
    otherResources?: ProductQueryResource[] | undefined;
    specifications?: ProductQueryArbitraryNameValues | undefined;
    multiSpecifications?: ProductQueryArbitraryNameValues[] | undefined;
    links?: ProductQueryLink[] | undefined;
    categoryBreadcrumb?: string | undefined;
    isBundle: boolean;
}

export interface ProductQueryProductItem {
    itemId: number;
    itemNumber?: string | undefined;
    isPrimary: boolean;
    supplierItemNumber?: string | undefined;
    name?: string | undefined;
    name2?: string | undefined;
    variantIndex: number;
    variantType?: string | undefined;
    variantName?: string | undefined;
    itemCanonicalUrl?: string | undefined;
    itemUrlSegment?: string | undefined;
    grossWeight?: number | undefined;
    color?: string | undefined;
    colorNuance?: string | undefined;
    clothingSize?: string | undefined;
    liters?: string | undefined;
    volts?: string | undefined;
    watts?: string | undefined;
    amperes?: string | undefined;
    energyLabel?: string | undefined;
    energyLabelLink?: string | undefined;
    energyProductDataSheetLink?: string | undefined;
    ean?: string | undefined;
    itemStatus: ItemStatusValues;
    dimensionsCm?: ProductQueryProductItemDimensions | undefined;
    dimensionsMm?: ProductQueryProductItemDimensions | undefined;
    euGaranEnabled?: boolean | undefined;
    euGaranBrand?: string | undefined;
    euGaranModelIdentifier?: string | undefined;
    euGaranYears?: number | undefined;
    images?: ProductQueryResource[] | undefined;
    otherResources?: ProductQueryResource[] | undefined;
    specifications?: ProductQueryArbitraryNameValues | undefined;
    multiSpecifications?: ProductQueryArbitraryNameValues[] | undefined;
    hazardSentences?: ProductQueryArbitraryNameValues | undefined;
    multiHazardSentences?: ProductQueryArbitraryNameValues[] | undefined;
    itemHazardSymbols?: string[] | undefined;
    sustainabiltyValues?: string[] | undefined;
    sustainabiltyLabels?: string[] | undefined;
    freightInfo?: ProductQueryFreightInfo | undefined;
    packagings?: ProductQueryPackaging[] | undefined;
    itemRelativeUrl?: string | undefined;
}

export interface ProductQueryProductItemDimensions {
    thickness?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    height?: number | undefined;
    depth?: number | undefined;
    diameter?: number | undefined;
}

export interface ProductQueryArbitraryNameValues {
    title?: string | undefined;
    data?: string[][] | undefined;
}

export interface ProductQueryFreightInfo {
    freightType?: FreightType | undefined;
    freightName?: string | undefined;
    freightDescription?: string | undefined;
}

export interface ProductQueryPackaging {
    name?: string | undefined;
    name2?: string | undefined;
    itemNumber?: string | undefined;
    unitsPerEmballage: number;
    packingReturnPriceDelivery?: PriceModel | undefined;
    packingReturnPriceHandIn?: PriceModel | undefined;
    salesUnitFormatted?: string | undefined;
    salesUnitLookup?: string | undefined;
}

export interface ProductQueryLink {
    url?: string | undefined;
    name?: string | undefined;
    target?: string | undefined;
}

export interface ItemNumberXlBygQueryResult {
    itemNumberMappings?: { [key: string]: string } | undefined;
}

export interface ProductPathsQueryResult {
    itemPaths?: { [key: string]: string } | undefined;
}

export interface BrandQueryResult {
    brands?: Brand[] | undefined;
}

export interface Brand {
    name?: string | undefined;
    url?: string | undefined;
    itemCount: number;
}

export interface CategoryQueryResult {
    categories?: string[] | undefined;
}

export interface ProductStockDetailsResponse {
    itemNo?: string | undefined;
    online?: ProductStockDetailsOnline | undefined;
    pickup?: ProductStockDetailsPickup | undefined;
}

export interface ProductStockDetails {
    title?: Translation | undefined;
    priceText?: Translation | undefined;
    statusText?: Translation | undefined;
    status: StockStatus;
    postalCode?: string | undefined;
    requiresPostalCode: boolean;
    calculatedDeliveryDate?: Date | undefined;
    maxQuantity?: number | undefined;
    freightDeliveryInfoState?: FreightDeliveryInfoState | undefined;
}

export interface ProductStockDetailsOnline extends ProductStockDetails {
    mightBeDisplayModel: boolean;
}

export enum FreightDeliveryInfoState {
    Valid = 'Valid',
    MissingOnlineWarehouse = 'MissingOnlineWarehouse',
    NoMatchingFreightZoneForPostalCode = 'NoMatchingFreightZoneForPostalCode',
    NoDeliveryToPostalCode = 'NoDeliveryToPostalCode',
    NoMatchingFreightOptionForFreightType = 'NoMatchingFreightOptionForFreightType',
    NoDepartmentForDelivery = 'NoDepartmentForDelivery',
    NotCalculated = 'NotCalculated',
}

export interface ProductStockDetailsPickup extends ProductStockDetails {
    warehouses?: WarehouseStockDetails[] | undefined;
}

export interface WarehouseStockDetails {
    id?: number | undefined;
    name?: string | undefined;
    title?: Translation | undefined;
    statusText?: Translation | undefined;
    status: StockStatus;
    mightBeDisplayModel: boolean;
}

export interface ProductStockDto {
    itemNumber?: string | undefined;
    itemStatus: ItemStatusValues;
    stockStatus: StockStatus;
    quantity: number;
}

export interface Data {
    [key: string]: any;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}
